/**
 * BMM — Shop the Look / Hotspot v3.0
 */
(function () {
  'use strict';

  function init(section) {
    var sid        = section.dataset.sectionId;
    var slidesWrap = document.getElementById('bmmSlides-' + sid);
    var btnPrev    = document.getElementById('bmmPrev-' + sid);
    var btnNext    = document.getElementById('bmmNext-' + sid);
    var indsWrap   = document.getElementById('bmmInds-' + sid);
    var pImg       = document.getElementById('bmmPImg-' + sid);
    var pPrev      = document.getElementById('bmmPPrev-' + sid);
    var pNext      = document.getElementById('bmmPNext-' + sid);
    var pThumbsW   = document.getElementById('bmmPThumbs-' + sid);
    var pTypeEl    = document.getElementById('bmmPType-' + sid);
    var pNameEl    = document.getElementById('bmmPName-' + sid);
    var pLinkEl    = document.getElementById('bmmPLink-' + sid);
    var pPriceEl   = document.getElementById('bmmPPrice-' + sid);
    var pCmpEl     = document.getElementById('bmmPCmp-' + sid);

    if (!slidesWrap) return;

    var slides  = Array.from(slidesWrap.querySelectorAll('.bmm-hs__slide'));
    var inds    = indsWrap ? Array.from(indsWrap.querySelectorAll('.bmm-hs__ind')) : [];
    var N       = slides.length;
    var cur     = 0;
    var imgList = [];
    var imgIdx  = 0;
    var fadeT   = null;
    var lastPid = null;
    var activeDotByCur = {};

    /* ── LEFT SLIDER ── */
    function goSlide(idx) {
      slides[cur].classList.remove('is-active');
      if (inds[cur]) inds[cur].classList.remove('is-active');
      cur = ((idx % N) + N) % N;
      slides[cur].classList.add('is-active');
      if (inds[cur]) inds[cur].classList.add('is-active');
      /* Restore dot highlight for this slide if previously clicked */
      slidesWrap.querySelectorAll('.bmm-hs__dot').forEach(function (d) { d.classList.remove('is-active'); });
      if (activeDotByCur[cur]) activeDotByCur[cur].classList.add('is-active');
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goSlide(cur - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goSlide(cur + 1); });
    inds.forEach(function (ind, i) { ind.addEventListener('click', function () { goSlide(i); }); });

    /* F7: Touch swipe for lifestyle slider */
    var tsX = 0, tsDown = false;
    slidesWrap.addEventListener('touchstart', function (e) {
      tsX = e.touches[0].clientX; tsDown = true;
    }, { passive: true });
    slidesWrap.addEventListener('touchend', function (e) {
      if (!tsDown) return;
      var dx = e.changedTouches[0].clientX - tsX;
      if (Math.abs(dx) > 40) { dx < 0 ? goSlide(cur + 1) : goSlide(cur - 1); }
      tsDown = false;
    }, { passive: true });

    /* ── DOT CLICK ── */
    slidesWrap.addEventListener('click', function (e) {
      /* Walk up from click target to find the dot button */
      var t = e.target;
      while (t && t !== slidesWrap) {
        if (t.classList && t.classList.contains('bmm-hs__dot')) {
          e.preventDefault();
          e.stopPropagation();
          onDotClick(t);
          return;
        }
        t = t.parentNode;
      }
    });

    function onDotClick(dot) {
      /* Clear all dots, mark this one active */
      slidesWrap.querySelectorAll('.bmm-hs__dot').forEach(function (d) { d.classList.remove('is-active'); });
      dot.classList.add('is-active');
      activeDotByCur[cur] = dot;

      /* Read data */
      var title   = dot.dataset.title   || '';
      var ptype   = dot.dataset.type    || '';
      var url     = dot.dataset.url     || '#';
      var price   = dot.dataset.price   || '';
      var cmp     = dot.dataset.compare || '';
      var isSale  = dot.dataset.sale    === 'true';
      var imgsRaw = dot.dataset.imgs    || '';

      imgList = imgsRaw.split('||').filter(function (s) { return s.trim() !== ''; });
      imgIdx  = 0;

      /* Update right panel text */
      if (pTypeEl)  pTypeEl.textContent  = ptype ? ptype.toUpperCase() : '';
      if (pNameEl)  pNameEl.textContent  = title;
      if (pLinkEl)  pLinkEl.href         = url;
      if (pPriceEl) pPriceEl.textContent = price;
      if (pCmpEl) {
        if (isSale && cmp) { pCmpEl.textContent = cmp; pCmpEl.style.display = 'inline'; }
        else { pCmpEl.style.display = 'none'; }
      }

      /* Update image + thumbs only if product changed */
      setImg(0, true);
      if (dot.dataset.pid !== lastPid) {
        buildThumbs();
        lastPid = dot.dataset.pid;
      } else {
        syncThumbs();
      }
    }

    /* ── PRODUCT IMAGE ── */
    function setImg(idx, force) {
      if (!pImg || imgList.length === 0) return;
      imgIdx = ((idx % imgList.length) + imgList.length) % imgList.length;

      if (fadeT) { clearTimeout(fadeT); fadeT = null; }
      if (force) {
        pImg.style.opacity = '1';
        pImg.src = imgList[imgIdx];
      } else {
        pImg.style.opacity = '0';
        fadeT = setTimeout(function () {
          pImg.src = imgList[imgIdx];
          pImg.style.opacity = '1';
          fadeT = null;
        }, 200);
      }

      syncThumbs();
      var singleImg = imgList.length <= 1;
      if (pPrev) { pPrev.disabled = singleImg; pPrev.style.display = singleImg ? 'none' : ''; }
      if (pNext) { pNext.disabled = singleImg; pNext.style.display = singleImg ? 'none' : ''; }
    }

    if (pPrev) pPrev.addEventListener('click', function () { setImg(imgIdx - 1, false); });
    if (pNext) pNext.addEventListener('click', function () { setImg(imgIdx + 1, false); });

    /* ── THUMBNAILS ── */
    function buildThumbs() {
      if (!pThumbsW) return;
      /* Remove old thumb buttons and rebuild to match imgList count */
      pThumbsW.innerHTML = '';
      imgList.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'bmm-hs__pthumb' + (i === 0 ? ' is-active' : '');
        btn.dataset.idx = i;
        btn.setAttribute('aria-label', 'Image ' + (i + 1));
        btn.addEventListener('click', function () { setImg(i, false); });
        pThumbsW.appendChild(btn);
      });
    }

    function syncThumbs() {
      if (!pThumbsW) return;
      pThumbsW.querySelectorAll('.bmm-hs__pthumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === imgIdx);
      });
    }

    /* ── INIT DEFAULT — first dot of first slide ── */
    (function initDefault() {
      var firstDot = slidesWrap.querySelector('.bmm-hs__dot');
      if (!firstDot) return;

      firstDot.classList.add('is-active');
      activeDotByCur[0] = firstDot;

      var imgsRaw = firstDot.dataset.imgs || '';
      imgList = imgsRaw.split('||').filter(function (s) { return s.trim() !== ''; });
      imgIdx  = 0;

      /* Server-rendered image is already correct — just sync controls */
      if (pImg && imgList.length > 0 && !pImg.src) {
        pImg.src = imgList[0];
      }

      if (pPrev) pPrev.disabled = imgList.length <= 1;
      if (pNext) pNext.disabled = imgList.length <= 1;

      /* Build thumbs from first dot images */
      lastPid = firstDot.dataset.pid || null;
      buildThumbs();
    })();
  }

  function initAll() {
    document.querySelectorAll('.bmm-hs[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.bmm-hs[data-section-id]');
    if (s) init(s);
  });

  /* ── KEYBOARD NAVIGATION — ArrowLeft/Right navigates lifestyle slides ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    /* Only fire if focus is inside a hotspot section */
    var section = document.activeElement && document.activeElement.closest('.bmm-hs');
    if (!section) return;
    var sid = section.dataset.sectionId;
    var btnId = e.key === 'ArrowLeft' ? 'bmmPrev-' + sid : 'bmmNext-' + sid;
    var btn = document.getElementById(btnId);
    if (btn) { btn.click(); e.preventDefault(); }
  });

})();
